import { render, staticRenderFns } from "./roleManageDetail.vue?vue&type=template&id=0a12f7fc&scoped=true"
import script from "./roleManageDetail.vue?vue&type=script&lang=js"
export * from "./roleManageDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a12f7fc",
  null
  
)

export default component.exports